import React from 'react';

import { TabsTypes } from "components/Tabs/types";
import { TabsStatic } from "components/Tabs/components/Tabs/Tabs";

interface ITabPanelProps {
  id: string,
  selected: boolean,
  tabPanelClassname: string,
  selectedTabPanelClassname: string,
  children: React.ReactElement,
}
  
const TabPanel: React.FC<ITabPanelProps> & TabsStatic = (props) => {
  const {
    children,
    selected,
    tabPanelClassname,
    selectedTabPanelClassname
  } = props;

  return (
      <div
        className={`${tabPanelClassname} ${selected ? selectedTabPanelClassname : ""}`}
      > 
        {children}
      </div>
  )
}
TabPanel.tabsRole = TabsTypes.TabPanel;
export default TabPanel;